import { motion } from "framer-motion";
import { FileSignature, CalendarClock, Wallet, Headphones } from "lucide-react";
import { IMAGES } from "@/lib/config";

const pillars = [
  { icon: FileSignature, title: "Garanzie scritte", desc: "Ogni impegno è messo nero su bianco nel contratto. Nessuna promessa verbale." },
  { icon: CalendarClock, title: "Tempi certi", desc: "Data di consegna definita in contratto, con tutela per te in caso di ritardi imputabili all'impresa." },
  { icon: Wallet, title: "Costi definitivi", desc: "Il prezzo concordato non cambia, salvo nuove modifiche richieste o alterazioni strutturali occulte." },
  { icon: Headphones, title: "Assistenza continua", desc: "Un referente unico che ti segue prima, durante e dopo i lavori." },
];

export default function Trust() {
  return (
    <section id="perche-noi" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <motion.img
              initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
              src={IMAGES.living2} alt="Ambiente ristrutturato" className="rounded-2xl w-full h-[520px] object-cover shadow-xl"
            />
            <motion.div
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.2 }}
              className="absolute -bottom-8 -right-4 md:right-8 bg-brand-gold text-brand-ink rounded-2xl p-7 shadow-2xl max-w-[240px]"
            >
              <div className="font-display text-2xl font-extrabold mb-1">Sopralluogo gratuito</div>
              <div className="text-brand-ink/70 font-semibold text-sm">preventivo dettagliato senza alcun impegno</div>
            </motion.div>
          </div>

          <div>
            <span className="text-brand-terracotta font-semibold tracking-[0.2em] uppercase text-sm">Perché sceglierci</span>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold text-brand-ink mt-4 mb-8">
              Professionalità e trasparenza, in ogni fase
            </h2>
            <div className="grid sm:grid-cols-2 gap-7">
              {pillars.map((p, i) => (
                <motion.div
                  key={p.title}
                  initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                  data-testid={`pillar-${i}`}
                >
                  <div className="w-11 h-11 rounded-xl bg-brand-ink/5 flex items-center justify-center mb-3">
                    <p.icon className="text-brand-terracotta" size={22} />
                  </div>
                  <h3 className="font-display text-lg font-bold text-brand-ink mb-1.5">{p.title}</h3>
                  <p className="text-brand-slate/65 text-sm leading-relaxed">{p.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
